import { Browser } from "../utils/Browser";
import { PAL } from "./PlatformAdapters";
export class StorageAdapter {
    constructor() {
        this._storage = Browser.window.localStorage;
        this._supported = this.checkSupport();
    }
    checkSupport() {
        return this._storage != null && typeof (this._storage.getItem) === 'function' &&
            typeof (this._storage.setItem) === 'function';
    }
    getItem(key) {
        if (this._supported)
            return this._storage.getItem(key);
        else
            return null;
    }
    setItem(key, value) {
        this._supported && this._storage.setItem(key, value);
    }
    removeItem(key) {
        this._supported && this._storage.removeItem(key);
    }
    clear() {
        this._supported && this._storage.clear();
    }
    getCount() {
        if (this._supported)
            return this._storage.length || 0;
        else
            return 0;
    }
}
PAL.register("storage", StorageAdapter);
